import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../common/containers/icon';
import { feedbackFormShape } from './feedbackPropTypes';
import { getFeedbackCategory } from './feedbackCopy';

/**
 * Offers one option per available feedback form. The icon and the supporting line come from the
 * shared copy; the title is the FormType name so accounts see the label they were provisioned.
 */
const FeedbackCategoryPicker = ({
  forms,
  onSelect
}) => /*#__PURE__*/React.createElement("ul", {
  className: "t-feedback-categories"
}, forms.map(({
  categoryId,
  name
}) => {
  const {
    glyph,
    optionDescription
  } = getFeedbackCategory(categoryId);
  return /*#__PURE__*/React.createElement("li", {
    key: categoryId,
    className: "t-feedback-categories__item"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `t-feedback-category t-feedback-category--${categoryId}`,
    onClick: () => onSelect(categoryId)
  }, /*#__PURE__*/React.createElement("span", {
    className: "t-feedback-category__icon",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: glyph
  })), /*#__PURE__*/React.createElement("span", {
    className: "t-feedback-category__text"
  }, /*#__PURE__*/React.createElement("span", {
    className: "t-feedback-category__title"
  }, name), /*#__PURE__*/React.createElement("span", {
    className: "t-feedback-category__description"
  }, optionDescription))));
}));
FeedbackCategoryPicker.propTypes = {
  forms: PropTypes.arrayOf(feedbackFormShape).isRequired,
  onSelect: PropTypes.func.isRequired
};
export default FeedbackCategoryPicker;